<template>
  <MSButton class="play-now-btn" :type="'play'" @click="playGame.playNow">Play Now</MSButton>
</template>
<script setup lang="ts">
  import { usePlayGame } from '@/store/PlayGame'
  const playGame = usePlayGame()
</script>
